import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import Api from '@/services/http'
import { commonUrl } from '@/services/url'
import type { AppDispatch } from '@/store'
import type * as Types from './type'
import { messageList } from '@/services/api'

const initialState: Types.messageType = {
  messageList: {
    pageNum: 1,
    list: [],
    hasNext: false,
    socketData: [],
  },
  unReadMessageCount: 0,
  notifyCount: 0,
}

/**
 * 消息中心
 */
const messageSlice = createSlice({
  name: 'message',
  initialState: initialState,
  reducers: {
    setMessageList(state, action) {
      const { pageNum = 1, list, hasNext } = action.payload
      return {
        ...state,
        messageList: {
          pageNum,
          hasNext,
          list: pageNum >= 2 ? state.messageList.list.concat(list) : list,
        },
      }
    },
    setSocketMessageList(state, action: PayloadAction<Types.IMessageInfo[]>) {
      const data = action.payload as any
      const list = data.length ? state.messageList.socketData.concat(data) : data
      return {
        ...state,
        ...state.messageList,
        socketData: list,
      }
    },
    setUnReadMessageCount(state, action: PayloadAction<{ unReadCount: number }>) {
      return {
        ...state,
        unReadMessageCount: action.payload.unReadCount,
      }
    },
    setNotifyCount(state, action: PayloadAction<{ notifyCount: number }>) {
      return {
        ...state,
        notifyCount: action.payload.notifyCount,
      }
    },
  },
})

export const { setMessageList, setUnReadMessageCount, setNotifyCount } = messageSlice.actions

/** 获取消息中心数据 */
export const queryMessageList =
  (props: { pageNum?: number; pageSize?: number; upUnRead?: boolean } = {}) =>
  async (dispatch: AppDispatch) => {
    const { pageNum = 1, pageSize = 10 } = props
    const response = await messageList({ pageNum, pageSize, appId: 'ONE02', upUnRead: props.upUnRead })

    const list =
      response.data.list?.map((item) => {
        let msgBody = null
        try {
          if (item.msgBody) {
            msgBody = JSON.parse(item.msgBody)
            if (msgBody.extInfo) {
              msgBody.extInfo = JSON.parse(msgBody.extInfo)
            }
          }
        } catch (error) {}
        return {
          ...item,
          msgBody,
        }
      }) || []

    dispatch(setMessageList({ pageNum, list, hasNext: list.length == pageSize }))
    //已读
    const msgSeq = list
      .filter((message: any) => !message.read)
      .map((item: any) => {
        return item.msgSeq
      })
    if (msgSeq.length) {
      await Api.admin.post(commonUrl.messageRead, { msgSeqs: msgSeq, appId: 'ONE02' })
    }
  }

/** 获取消息中心未读数 */
export const getCountOfUnread = () => async (dispatch: AppDispatch) => {
  const { data } = await Api.admin.post<Types.ICountOfUnreadResponse>(commonUrl.messageCount, { appId: 'ONE02' })
  dispatch(setUnReadMessageCount({ unReadCount: data.unReadCount }))
}

export default messageSlice.reducer
